function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { pos2key, invRanks } from './util.js';
import * as cg from './types.js';
export var initial = 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR';
var roles = {
  p: 'pawn',
  r: 'rook',
  n: 'knight',
  b: 'bishop',
  q: 'queen',
  k: 'king'
};
var letters = {
  pawn: 'p',
  rook: 'r',
  knight: 'n',
  bishop: 'b',
  queen: 'q',
  king: 'k'
};
export function read(fen) {
  if (fen === 'start') fen = initial;
  var pieces = new Map();
  var row = 7,
    col = 0;
  var _iterator = _createForOfIteratorHelper(fen),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var c = _step.value;
      switch (c) {
        case ' ':
        case '[':
          return pieces;
        case '/':
          --row;
          if (row < 0) return pieces;
          col = 0;
          break;
        case '~':
          {
            var piece = pieces.get(pos2key([col - 1, row]));
            if (piece) piece.promoted = true;
            break;
          }
        default:
          {
            var nb = c.charCodeAt(0);
            if (nb < 57) col += nb - 48;else {
              var role = c.toLowerCase();
              pieces.set(pos2key([col, row]), {
                role: roles[role],
                color: c === role ? 'black' : 'white'
              });
              ++col;
            }
          }
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return pieces;
}
export function write(pieces) {
  return invRanks.map(function (y) {
    return cg.files.map(function (x) {
      var piece = pieces.get(x + y);
      if (piece) {
        var p = letters[piece.role];
        if (piece.color === 'white') p = p.toUpperCase();
        if (piece.promoted) p += '~';
        return p;
      } else return '1';
    }).join('');
  }).join('/').replace(/1{2,}/g, function (s) {
    return s.length.toString();
  });
}